import styled from 'styled-components'

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.hasSubReasons ? 'repeat(2, minmax(0, 1fr))' : '1fr')};
  gap: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`
